<template>
  <div class="toolbar-wrapper">
    <div class="toolbar-filtros align-center justify-space-between">
      <div class="pl-3">
        <v-icon class="icone-view left" @click="$emit('viewGrid')"
                :color="`${modoVisualizacao === 'grid' ? $vuetify.theme.primary : ''}`">
          grid_view
        </v-icon>
        <v-icon class="icone-view right" @click="$emit('viewList')"
                :color="`${modoVisualizacao === 'list' ? $vuetify.theme.primary : ''}`">
          view_list
        </v-icon>
      </div>
      <v-chip class="search-box-wrapper" style="height: 30px;">
        <v-icon class="pr-1">search</v-icon>
        <v-text-field
            v-model="filtroNome"
            label="Buscar por nome"
            single-line
            hide-details
            solo
            maxlength="50"
            class="search-box"
            height="1"
            :style="{ width: searchTextSize + 'px' }"
            @input="resizeSearchBox"
        ></v-text-field>
      </v-chip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FiltroPrefeituras',
  props:['modoVisualizacao'],
  data() {
    return {
      filtroNome: '',
      searchTextSize: 140,
    }
  },
  methods: {
    resizeSearchBox(valor) {
      this.searchTextSize = this.filtroNome.length > 0 ? this.filtroNome.length * 7.5 : 140;
      this.atualizarBusca(valor)
    },
    atualizarBusca(valor){
      this.$emit('atualizarBusca', valor)
    }
  },
}
</script>

<style lang="stylus">
.toolbar-wrapper {
  height: 60px;
}

.toolbar-filtros {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  background-color: #fff;
  z-index: 1;
  display: flex;
  justify-content: flex-end;
}

.search-box-wrapper {
  display: flex;
  align-items: center;
  margin-right: 16px;
}

.search-box
  min-width: 140px
  max-width: 600px

.theme--light.v-text-field--solo>.v-input__control>.v-input__slot
  padding-left 0 !important
  padding-right 0 !important
  background: transparent !important
  -webkit-box-shadow unset !important
  box-shadow unset !important

.icone-view
  border-color grey
  border-bottom 1px solid
  border-top 1px solid

.icone-view.left
  border-left 1px solid
  border-right 1px solid
  border-bottom-left-radius 4px
  border-top-left-radius 4px

.icone-view.right
  border-right 1px solid
  border-bottom-right-radius 4px
  border-top-right-radius 4px

</style>
